// extracted by mini-css-extract-plugin
export default {"container":"Section6_container__LZy8V","contentContainer":"Section6_contentContainer__mU8sW","quote":"Section6_quote__TXDg5","btnContainer":"Section6_btnContainer__kXmP-"};